<template>
  <b-modal v-model="modal" size="lg" hide-footer>
    <template #modal-title> Datos para el launch </template>
    <form
      @submit.prevent="
        $emit('launch', { token, operatorId, casinoToken, isoCode })
      "
    >
      <vs-input
        class="shadow-lg mb-2"
        border
        v-model="token"
        placeholder="TOKEN WALLET"
        @focus="clipboarding('token')"
      />
      <vs-input
        class="shadow-lg mb-2"
        border
        v-model="operatorId"
        placeholder="OPERATOR"
        @focus="clipboarding('operator')"
      />
      <vs-input
        class="shadow-lg mb-2"
        border
        v-model="casinoToken"
        placeholder="CASINO TOKEN"
        @focus="clipboarding('casinoToken')"
      />
      <vs-input
        class="shadow-lg mb-2"
        border
        v-model="isoCode"
        placeholder="USD"
        @focus="clipboarding('isoCode')"
      />
      <vs-button>INICIAR</vs-button>
    </form>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      modal: true,
      token: '',
      operatorId: '',
      casinoToken: '',
      isoCode: '',
    };
  },
  methods: {
    async clipboarding(from) {
      const data = await navigator.clipboard.readText();

      let tokenWallet = '';
      let operator = '';
      let client = '';
      let currency = '';

      try {
        const { tokenWallet: tW,operator: o,client: c,currency:curr } = JSON.parse(data);
        tokenWallet = tW;
        operator = o
        client = c
        currency = curr
      } catch (error) {
        console.log('error', error);
      }

      switch (from) {
        case 'token':
          this.token = tokenWallet;
          break;
        case 'operator':
          this.operatorId = operator;
          break;
        case 'casinoToken':
          this.casinoToken = client;
          break;
        case 'isoCode':
          this.isoCode = currency;
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
